import { useMutationWithErrorHandler } from "@nens/ranalib";
import { getHCCApi } from "@nens/threedi/openapi-client";

import { useUpdateThreediModelQuery } from "@/queries/query-hcc-models";

export const useDeleteThreediModelMutation = (
  schematisationId: number | undefined,
  revisionId: number | undefined
) => {
  const updateThreediModel = useUpdateThreediModelQuery({ schematisationId, revisionId });
  return useMutationWithErrorHandler(async (modelId: number) => {
    await getHCCApi().threedimodelsDelete({ id: modelId });

    updateThreediModel(null);
  });
};

export const useCreateThreediModelMutation = (
  schematisationId: number | undefined,
  revisionId: number | undefined
) => {
  const updateThreediModel = useUpdateThreediModelQuery({ schematisationId, revisionId });
  return useMutationWithErrorHandler(async () => {
    if (schematisationId === undefined || revisionId === undefined)
      throw new Error("schematisationId and revisionId are required");

    const model = await getHCCApi().schematisationsRevisionsCreateThreedimodel({
      id: revisionId,
      schematisationPk: schematisationId,
      data: { inheritFromPreviousRevision: true },
    });

    updateThreediModel(model);

    return model;
  });
};

export const useRecreateThreediModelMutation = (
  schematisationId: number | undefined,
  revisionId: number | undefined
) => {
  const updateThreediModel = useUpdateThreediModelQuery({ schematisationId, revisionId });
  return useMutationWithErrorHandler(async (modelId: number) => {
    if (schematisationId === undefined || revisionId === undefined)
      throw new Error("schematisationId and revisionId are required");

    await getHCCApi().threedimodelsDelete({ id: modelId });

    const model = await getHCCApi().schematisationsRevisionsCreateThreedimodel({
      id: revisionId,
      schematisationPk: schematisationId,
      data: { inheritFromPreviousThreedimodel: true },
    });

    updateThreediModel(model);

    return model;
  });
};
